export default __webpack_public_path__ + "static/media/Canberra-2022.9699aa8a.jpg";